import React from 'react';
import { Profile } from '@/types/auth';
import { Button } from '@/components/ui/button';
import { ExternalLink, Link as LinkIcon } from 'lucide-react';

interface SocialLinksWidgetProps {
  profile: Profile;
}

export const SocialLinksWidget: React.FC<SocialLinksWidgetProps> = ({ profile }) => {
  const customLinks = Array.isArray(profile.custom_links) ? profile.custom_links : [];

  if (customLinks.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground">
        <div className="text-center">
          <LinkIcon className="h-8 w-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No links available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <h3 className="text-sm font-medium text-muted-foreground mb-4">Links</h3>
      
      <div className="space-y-3 h-[calc(100%-2rem)] overflow-y-auto">
        {customLinks.map((link: any, index: number) => (
          <Button
            key={index}
            variant="outline"
            className="w-full justify-between h-auto p-3"
            asChild
          >
            <a 
              href={link.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <LinkIcon className="h-4 w-4 text-primary" />
                </div>
                <div className="text-left min-w-0 flex-1">
                  <div className="font-medium text-sm truncate">{link.title || 'Link'}</div>
                  {link.description && (
                    <div className="text-xs text-muted-foreground truncate">
                      {link.description}
                    </div>
                  )}
                </div>
              </div>
              <ExternalLink className="h-4 w-4 text-muted-foreground flex-shrink-0" />
            </a>
          </Button>
        ))}
      </div>
    </div>
  );
};